import {
  faArrowDownWideShort,
  faArrowUpWideShort,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack } from '@sixui/ui';

import type { IContainerProps } from '~/components/utils/Container';
import { Link } from '~/components/atoms/Link';
import { Table } from '~/components/molecules/Table';

export type ITableSortableHeaderProps = IContainerProps & {
  children: React.ReactNode;
  sortBy: string;
  sortOrder?: string;
  onChange?: (sortBy: string, sortOrder: string) => void;
  reverseIcon?: boolean;
};

export const TableSortableHeader: React.FC<ITableSortableHeaderProps> = (
  props,
) => {
  const { sx, children, sortBy, sortOrder, onChange, reverseIcon } = props;
  const iconSortOrder = reverseIcon
    ? sortOrder === 'asc'
      ? 'desc'
      : 'asc'
    : sortOrder;

  return (
    <Table.Header sx={sx}>
      <Link
        to="#"
        onClick={(event) => {
          event.preventDefault();
          onChange?.(sortBy, sortOrder === 'asc' ? 'desc' : 'asc');
        }}
      >
        <Stack horizontal gap={2} align="center">
          {children}
          {sortOrder && (
            <FontAwesomeIcon
              icon={
                iconSortOrder === 'asc'
                  ? faArrowUpWideShort
                  : faArrowDownWideShort
              }
            />
          )}
        </Stack>
      </Link>
    </Table.Header>
  );
};
